import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NbAuthService } from '@nebular/auth';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(
    private authService: NbAuthService,
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.authService.getToken().pipe(
      switchMap((token) => {
        if (token.isValid()) {
          // If we use a token the keyword is Token is we used a kwt the keyword is Bearer
          const authorizationKeyword = token.getOwnerStrategyName() === 'jwt' ? 'Bearer' : 'Token';
          const headers = req.headers.append('Authorization', `${authorizationKeyword} ${token}`);
          req = req.clone({ headers });
        }

        return next.handle(req);
      }),
    );
  }
}
